import {
  REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT,
  REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT_DONE,
  ProductProfitStatisticsActions
} from "./types";
import { ProductProfitStatistics } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchStoreProfitByProductStatistics(): ProductProfitStatisticsActions {
  return {
    type: REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT,
    payload: []
  };
}

function fetchStoreProfitByProductStatisticsDone(
  productProfitStatistics: ReadonlyArray<ProductProfitStatistics>
): ProductProfitStatisticsActions {
  return {
    type: REQUEST_STOREPROFITSTATISTICS_BY_PRODUCT_DONE,
    payload: productProfitStatistics
  };
}

/* Thunks goes here */
export const thunkFetchProductProfitStatistics = (
  periodFrom: Date,
  periodTo: Date,
  storeId: string
) => async (dispatch: any) => {
  try {
    dispatch(fetchStoreProfitByProductStatistics());
    const result = await StatisticsApi.getProductProfitStatistics(
      periodFrom,
      periodTo,
      storeId
    );

    if (isOk(result)) {
      dispatch(fetchStoreProfitByProductStatisticsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchStoreProfitByProductStatisticsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
